module.exports = __webpack_public_path__ + "img/map_7.ce6832ad.webp";